const rules = {
	user: {
		static: [
			"dashboard:viewLink",
			"dashboard:products",
			"ticket-options:deleteTicket",
		],
	},

	admin: {
		static: [
			"dashboard:view",
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"contacts-page:deleteContact",
			"connections-page:actionButtons",
			"connections-page:addConnection",
			"connections-page:editOrDeleteConnection",
			"tickets-manager:closeAll",
			"dashboard:kanban",
			"dashboard:tags",
			"dashboard:products",
			"dashboard:campaigns",
			"dashboard:flowbuilders",
			"dashboard:schedules",
		],
	},
};

export default rules;
